import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PropTypes from "prop-types";

const QuilEditor = ({ value, id, onChange }) => {
  return (
    <ReactQuill
      id={id}
      theme="snow"
      onChange={(val, delta, source) => {
        if (source === "api") {
          return;
        }
        onChange(val);
      }}
      value={value}
    />
  );
};
QuilEditor.defaultProps = {
  id: "quillEditorId",
};
QuilEditor.propTypes = {
  value: PropTypes.string.isRequired,
  id: PropTypes.string,
  onchange: PropTypes.func,
};
export default QuilEditor;
